import React from 'react';
import './App.scss';

function App() {
    return (
        <div className="App">
           <a href={"https://kalenderapp.aptinstall.de/"}><button className={"btn btn-lg"}>Der Kalendergenerator liegt jetzt hier :) Drück mich</button></a>
        </div>
    );
}

export default App;
